import React from 'react';
import { Combo } from 'fw/forms';

class NotificationTypeCombo extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this._isMounted = false;
    }

    completed = () => { return this._ctrl.completed(); }
    flag = () => { return this._ctrl.flag(); }

    componentDidMount = () => {
        this._isMounted = true;

        this.loadNotificationTypes(null);
    }

    loadNotificationTypes = () => {
        let items = [];

        items.push({ label: "System", value: "SYS"});
        items.push({ label: "User Defined", value: "USR"});

        this.setState({items});
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <Combo
                {...this.props}
                placeholder={this.props.placeholder ? this.props.placeholder : "Select Type"}
                items={this.state.items}
                searchable={true}
                ref={(c) => { this._ctrl = c }} />
        )
    }
}

export default NotificationTypeCombo;

// Mark this as a form component
NotificationTypeCombo.defaultProps = {
    formControl: true,
    managed: false
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/notificationTypeCombo/NotificationTypeCombo.js